<template>
    <div class="animated fadeIn">
        <b-row v-if="loading">
            <b-col cols="12" md="6">
                <atom-spinner
                    :animation-duration="1000"
                    :size="60"
                    color="#ff1d5e"
                    class="float-right my-5"
                />
            </b-col>
        </b-row>
        <div v-if="!loading">
            <component-header
                title="Service Request"
                :hasSearch="true"
                :hasReload="true"
                :isLoading="loading"
                :hasCreate="true"
                @create-press="$router.push({ name: 'Create Request' })"
                createButtonText="Create Service Request"
                @search-query="(val) => (filter = val)"
                @reload-data="loadServiceRequestList"
            />
            <b-card>
                <div class="mt-2">
                    <b-table
                        class="table-radius mt-3"
                        :dark="dark"
                        :hover="hover"
                        :striped="striped"
                        :bordered="bordered"
                        :small="small"
                        :fixed="fixed"
                        responsive
                        id="my-table"
                        :current-page="currentPage"
                        :per-page="perPage"
                        :items="servicerequests"
                        thead-class="header"
                        :fields="Columns"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                    >
                        <template slot="cell(action)" slot-scope="data">
                            <div class="inline_btnTable">
                                <ActionButtonGroup
                                    showView
                                    showEdit
                                    showDelete
                                    @view="navigateTo(data.item, 'View Request')"
                                    @edit="navigateTo(data.item, 'Edit Request')"
                                    @delete="deleteReq(data)"
                                />
                            </div>
                        </template>
                    </b-table>
                </div>
                <div
                    class="pagination-wrapper"
                    v-if="servicerequests.length > perPage"
                >
                    <b-pagination
                        v-model="currentPage"
                        :per-page="perPage"
                        :total-rows="servicerequests.length"
                        aria-controls="my-table"
                        prev-text="Prev"
                        next-text="Next"
                        hide-goto-end-buttons
                    ></b-pagination>
                </div>
                <!-- <p v-else style="text-align:center;padding-top:10px;">No data available!</p> -->
            </b-card>
        </div>
    </div>
</template>
<script>
import ComponentHeader from "@/components/componentNewHeader";
import { AtomSpinner } from "epic-spinners";
import ActionButtonGroup from "@/components/Common/ActionButtonGroup.vue";
export default {
    name: "servicerequestdetails",
    components: { ComponentHeader, AtomSpinner, ActionButtonGroup },
    data() {
        return {
            filter: "",
            perPage: 10,
            sortBy: "createdAt",
            loading: false,
            sortDesc: true,
            hover: true,
            striped: false,
            bordered: true,
            small: false,
            dark: false,
            fixed: false,
            currentPage: 1,
            Columns: [
                { key: "Category", sortable: true },
                { key: "Description" },
                { key: "Scope" },

                { key: "Severity" },
                { key: "Status" },

                { key: "action", class: "text-center" },
            ],
        };
    },
    computed: {
        servicerequests() {
            let data =
                this.$store.getters["servicerequest/GetServiceRequestList"];
            let ServiceRequestList = [];
            if (Array.isArray(data) && data.length > 0) {
                data.map((obj) => {
                    let arrayObj = {
                        Category: obj.name,
                        Description: obj.description,
                        Scope: obj.scope,
                        Severity: obj.severity,
                        Status: obj.status,
                        id: obj._id,
                        ...obj,
                    };
                    ServiceRequestList.push(arrayObj);
                });
                const search = this.filter?.toLowerCase() || "";
                return search
                    ? ServiceRequestList.filter(
                          (el) =>
                              (el.Category || "")
                                  .toLowerCase()
                                  .includes(search) ||
                              (el.Description || "")
                                  .toLowerCase()
                                  .includes(search) ||
                              (el.Scope || "").toLowerCase().includes(search) ||
                              (el.Severity || "")
                                  .toLowerCase()
                                  .includes(search) ||
                              (el.Status || "").toLowerCase().includes(search),
                      )
                    : ServiceRequestList;
            } else {
                return [];
            }
        },
    },
    watch: {
        filter() {
            this.currentPage = 1;
        },
    },
    mounted() {
        this.loadServiceRequestList();
    },
    methods: {
        async loadServiceRequestList() {
            this.loading = true;
            try {
                await this.$store.dispatch(
                    "servicerequest/fetchServicerequestList",
                );
            } catch (error) {
                this.$toasted?.error(
                    error?.message || "Failed to load service requests",
                );
            } finally {
                this.loading = false;
            }
        },
        navigateTo(item, pathName) {
            const id = item.id || item._id;
            if (!id) return;
            const routes = {
                "View Request": `/setup/service-request/ViewRequest/${id}`,
                "Edit Request": `/setup/service-request/EditRequest/${id}`,
            };
            const path = routes[pathName];
            if (path) {
                this.$router.push(path);
            }
        },
        async deleteReq(data) {
            this.$swal({
                title: "Delete this ServiceRequest?",
                text: "Are you sure? You won't be able to revert this!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Yes, Delete it!",
                cancelButtonColor: "#d33",
                reverseButtons: true,
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("servicerequest/deleteRequest", data.item._id)
                        .then((result) => {
                            this.$toasted.success(
                                "Request Deleted Successfully",
                            );
                            this.$store
                                .dispatch(
                                    "servicerequest/fetchServicerequestList",
                                )
                                .catch((error) => {
                                    this.$toasted.error(error.message);
                                });
                        });
                }
            });
        },
    },
};
</script>
<style scoped>
.table-radius {
    border-radius: 12px;
}

.pagination-wrapper {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 1rem;
}

.pagination-wrapper :deep(.pagination) {
    display: inline-flex;
    flex-wrap: nowrap;
    margin-bottom: 0;
}

.btn-edit-servicerequest {
    background: #fe7b08;
    border-color: #fe7b08;
}

.inline_btnTable {
    display: inline-flex;
    align-items: center;
    flex-wrap: nowrap;
}

.inline_btnTable .button-circle {
    flex-shrink: 0;
}

@media (max-width: 768px) {
    .inline_btnTable {
        display: inline-flex;
        flex-wrap: nowrap;
        gap: 6px;
    }

    .inline_btnTable .button-circle {
        min-width: auto;
        padding: 0.25rem 0.5rem;
    }

    .inline_btnTable .mr-2 {
        margin-right: 0 !important;
    }
}

@media (max-width: 576px) {
    .inline_btnTable {
        display: inline-flex;
        flex-wrap: nowrap;
        gap: 4px;
    }

    .inline_btnTable .button-circle {
        padding: 0.2rem 0.4rem;
        font-size: 0.875rem;
    }

    .inline_btnTable .mr-2 {
        margin-right: 0 !important;
    }
}
</style>
